export default "__VITE_ASSET__46e35a37__"